"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const setSession_1 = (0, tslib_1.__importDefault)(require("../auth/setSession"));
const getSession_1 = (0, tslib_1.__importDefault)(require("../auth/getSession"));
const handleJWTRefresh_1 = (0, tslib_1.__importDefault)(require("./handleJWTRefresh"));
function onNetworkError({ networkError, operation, forward }) {
    if (networkError.statusCode === 401 && networkError.result.error === 'AuthError') {
        const { message } = networkError.result;
        if (message.toLowerCase().includes('jwt')) {
            return (0, handleJWTRefresh_1.default)({ networkError, operation, forward });
        }
        if (['sessionNotFound', 'invalidSignature'].includes(message)) {
            const session = (0, getSession_1.default)();
            console.log('Resetting session: ' + JSON.stringify(networkError.result, null, 2));
            if (session) {
                (0, setSession_1.default)(null, false);
            }
        }
        else {
            console.warn('Received too many nonce is invalid');
        }
    }
    else {
        console.warn('Network error:', networkError);
    }
}
exports.default = onNetworkError;
